'use strict';

StructurePreprocessorFactory.$inject = ['mx.SolutionBuilderAgent.BasePreprocessor'];
export default function StructurePreprocessorFactory(BasePreprocessor) {
	function StructurePreprocessor() {
		BasePreprocessor.apply(this);
		this.type = mx.SolutionBuilderAgent.PreprocessorType.Structure;
		return this;
	}

	StructurePreprocessor.prototype = angular.extend(Object.create(BasePreprocessor.prototype), {
		build: function () {
			const nodeId = this.getNodeId();
			if (nodeId) {
				if (this.executor.structureBuild) {
					return this.executor.structureBuild(nodeId);
				}
				return 'structureNodeId=' + nodeId;
			}
		},
		getNodeId: function () {
			return this.parameters.structureNodeId;
		},
	});

	return StructurePreprocessor;
}
